<div id="heading">
  <h1>College Profile</h1>
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" routerLink="/"><a href="#">Home</a></li>
      <li class="breadcrumb-item"><a href="#">About Us</a></li>
      <li class="breadcrumb-item active" aria-current="page">College Profile</li>
    </ol>
  </nav>
</div>

<div id="profile">
  <div class="container-fluid">
    <div class="card pl-3 pr-3 text-justify ">
      <h4 class="card-title text-center ">College Profile</h4>
      <div class="card-body text-justify">

        <!-- ABOUT COLLEGE -->
        <p class="lead">
          Guru Nanak Khalsa College, Yamuna Nagar, stands as a beacon of knowledge and enlightenment, carrying forward a
          legacy of academic excellence since its establishment in 1968. Founded to commemorate the quincentenary birth
          celebration of Sri Guru Nanak Dev Ji, the revered Sikh Guru, spiritual guide, and social reformer, the
          institution was envisioned as a great centre of ideal education that would nurture intellect, character, and
          moral values. Over the decades, the college has flourished into one of the most distinguished institutions in
          the region, proudly encompassing five dynamic faculties and 23 vibrant departments supported by nearly 100
          highly qualified and dedicated teaching faculties. With a thriving student community of more than 2000
          learners, the college offers a rich and diverse academic spectrum, including 17 undergraduate programmes, 7
          postgraduate programmes, and a PG diploma designed to meet both traditional educational pursuits and the
          evolving demands of modern industry.
        </p>

        <p class="lead">
          The college’s consistent pursuit of excellence has earned it prestigious recognitions at the national level.
          Guru Nanak Khalsa College was accredited with an A+ grade by NAAC in 2005 and has been reaccredited with an
          “A” grade in both 2014 and 2023—an affirmation of its unwavering commitment to high academic standards,
          quality teaching, and holistic development. Further enhancing its stature, the institution was honored with
          the esteemed status of “Centre with Potential for Excellence” by the University Grants Commission in 2006 and
          again in 2014–15, placing it among the select institutions recognized for outstanding academic potential and
          research culture.
        </p>

        <p class="lead">
          With its well-equipped laboratories, expansive library, vibrant co-curricular environment, and a strong
          emphasis on values and discipline, Guru Nanak Khalsa College continues to shape future leaders, thinkers, and
          professionals. It stands not only as an educational institution but as a transformative space where knowledge,
          culture, innovation, and character-building converge to empower students for a successful and meaningful
          future.
        </p>

        <!-- OBJECTIVES -->
        <h5>Objectives</h5>
        <hr class="pb-1" style="width:65px;">
        <p class="lead">The main Objectives of the college are:</p>

        <ul>
          <li>
            <p class="lead">
              1. To develop life-long learning habits among students so that they continue to grow intellectually,
              personally, and professionally throughout their lives.
            </p>
          </li>

          <li>
            <p class="lead">
              2. To adopt innovative and learner-centric methods of teaching, learning, and assessment that promote
              critical thinking, creativity, and academic excellence.
            </p>
          </li>

          <li>
            <p class="lead">
              3. To impart pre-employment and vocational knowledge along with related practical skills, enabling
              students to meet the expectations of the modern workforce with confidence and competence.
            </p>
          </li>

          <li>
            <p class="lead">
              4. To motivate students to embrace human values, especially the dignity of labour, social commitment,
              empathy, and a sense of responsibility toward the community.
            </p>
          </li>

          <li>
            <p class="lead">
              5. To equip learners with the essential knowledge, skills, and attitudes required to serve society and the
              nation meaningfully, contributing to its progress and well-being.
            </p>
          </li>

          <li>
            <p class="lead">
              6. To encourage students to imbibe the best of traditional, ethical, and scientific attitudes and values,
              fostering balanced personalities rooted in culture yet open to innovation.
            </p>
          </li>
        </ul>

        <!-- VISION -->
        <h5>Vision</h5>
        <hr class="pb-1" style="width:65px;">
        <p class="lead">
          To evolve into an institution recognized for its commitment to academic excellence, value-based education, and
          the holistic development of learners. Inspired by the timeless teachings of Sri Guru Granth Sahib Ji, the
          college envisions cultivating an intellectually vibrant and ethically grounded environment where compassion,
          humility, truth, and service guide all pursuits. With a strong thrust on enhancing student excellence and
          employability, the institution aspires to prepare graduates who are academically proficient, socially
          responsible, and culturally rooted fully equipped to meet the emerging challenges of a dynamic global society.
        </p>

        <!-- MISSION -->
        <h5>Mission</h5>
        <hr class="pb-1" style="width:65px;">
        <p class="lead">
          To provide career-oriented and quality education through innovative, student-centric teaching and learning
          practices, while promoting the holistic development of learners by integrating academic excellence,
          employability skills, and socio-cultural adaptability. Guided by the spiritual wisdom and humanistic values of
          Sri Guru Granth Sahib Ji, the college is committed to nurturing lifelong learners who embody integrity,
          professionalism, and respect for humanity. The mission further emphasizes strengthening employability through
          skill development, industry linkages, and experiential learning, alongside fostering research-oriented
          thinking, ethical leadership, and civic responsibility, enabling students to contribute meaningfully to
          national development and global progress.
        </p>
      </div>
      <div class="imgLoader"></div>
      <div class="container d-none d-lg-block">
        <div class="book">
          <div class="gap"></div>
          <div class="pages">
            <div class="page"></div>
            <div class="page"></div>
            <div class="page"></div>
            <div class="page"></div>
            <div class="page"></div>
            <div class="page"></div>
          </div>
          <div class="flips">
            <div class="flip flip1">
              <div class="flip flip2">
                <div class="flip flip3">
                  <div class="flip flip4">
                    <div class="flip flip5">
                      <div class="flip flip6">
                        <div class="flip flip7"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>